/**
 * Simple markdown to HTML converter for report answers.
 * Handles: bullet lists, numbered lists, and bold text.
 */
export function parseSimpleMarkdown(text: string): string {
  if (!text) return ''

  // Split into lines
  const lines = text.split('\n')
  const result: string[] = []
  let inList = false
  let listType: 'ul' | 'ol' | null = null

  for (const line of lines) {
    const trimmedLine = line.trim()

    // Check for bullet point (• or * or -)
    const bulletMatch = trimmedLine.match(/^[•*-]\s+(.*)/)
    // Check for numbered list (1. 2. etc)
    const numberedMatch = trimmedLine.match(/^\d+\.\s+(.*)/)

      if (bulletMatch) {
        if (!inList || listType !== 'ul') {
          if (inList) result.push(listType === 'ol' ? '</ol>' : '</ul>')
          result.push('<ul class="list-disc list-outside space-y-1 m-0 pl-4">')
          inList = true
          listType = 'ul'
        }
        result.push(`<li>${formatInlineMarkdown(bulletMatch[1])}</li>`)
      } else if (numberedMatch) {
        if (!inList || listType !== 'ol') {
          if (inList) result.push(listType === 'ol' ? '</ol>' : '</ul>')
          result.push('<ol class="list-decimal list-outside space-y-1 m-0 pl-4">')
          inList = true
          listType = 'ol'
        }
        result.push(`<li>${formatInlineMarkdown(numberedMatch[1])}</li>`)
    } else {
      // Close any open list
      if (inList) {
        result.push(listType === 'ol' ? '</ol>' : '</ul>')
        inList = false
        listType = null
      }

      // Regular paragraph
      if (trimmedLine) {
        result.push(`<p class="my-1">${formatInlineMarkdown(trimmedLine)}</p>`)
      }
    }
  }

  // Close any remaining open list
  if (inList) {
    result.push(listType === 'ol' ? '</ol>' : '</ul>')
  }

  return result.join('')
}

/**
 * Format inline markdown (bold, etc)
 */
function formatInlineMarkdown(text: string): string {
  // Convert **bold** to <strong>
  return text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
}
